export const faqItems = [
  {
    id: 1,
    question: '苹果视频需要注册才能观看吗？',
    answer: '完全不需要注册。打开苹果视频即可免费在线观看所有电影、电视剧、动漫和综艺资源，无需登录、无需付费，真正做到即点即看。',
  },
  {
    id: 2,
    question: '视频播放卡顿或加载慢怎么办？',
    answer: '我们为每部影片准备了多条播放线路。如果当前线路加载较慢，点击播放器下方的"切换线路"按钮即可切换到更流畅的源，保障高清不缓冲的观看体验。',
  },
  {
    id: 3,
    question: '苹果视频支持哪些设备观看？',
    answer: '支持PC端、手机端、平板端全平台观看。网页版自适应各种屏幕尺寸，同时提供iOS和Android客户端下载，随时随地畅享高清影视。',
  },
  {
    id: 4,
    question: '资源更新频率如何？新片多久上线？',
    answer: '内容团队每日更新，院线新片、热播剧集通常在上线后24小时内同步。香蕉视频、红桃视频、91视频、蜜桃视频等热门源的最新资源也会第一时间收录。',
  },
  {
    id: 5,
    question: '支持离线下载吗？',
    answer: 'APP客户端支持离线缓存功能，可将喜欢的影片下载到本地，在没有网络的环境下也能随时观看。下载内容在APP内播放，不占用手机相册空间。',
  },
  {
    id: 6,
    question: '遇到播放问题或有内容建议如何反馈？',
    answer: '您可以通过页面底部的"联系我们"入口提交反馈，也可以发送邮件至我们的客服邮箱。我们重视每一条用户反馈，通常在24小时内处理并回复。',
  },
];

export const topicItems = [
  { id: 1, name: '最新电影', count: '2.3w', hot: true },
  { id: 2, name: '热门剧集', count: '1.8w', hot: true },
  { id: 3, name: '高清专区', count: '9.6k', hot: false },
  { id: 4, name: '日韩精选', count: '7.2k', hot: true },
  { id: 5, name: '欧美大片', count: '6.5k', hot: false },
  { id: 6, name: '国产精品', count: '5.8k', hot: false },
  { id: 7, name: '动漫番剧', count: '8.4k', hot: true },
  { id: 8, name: '综艺娱乐', count: '4.1k', hot: false },
  { id: 9, name: '纪录大片', count: '3.2k', hot: false },
  { id: 10, name: '午夜剧场', count: '1.5w', hot: true },
];

export const carouselItems = [
  {
    id: 1,
    title: '2026暑期档热门大片专题',
    description: '汇集今夏最火爆的院线新片，动作、科幻、喜剧一网打尽，高清画质畅快观影。',
    tag: '热门专题',
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20poster%20aesthetic%20with%20warm%20golden%20and%20amber%20lighting%2C%20dramatic%20composition%20on%20deep%20charcoal%20background%2C%20film%20grain%20texture%2C%20premium%20entertainment%20visual%2C%20sophisticated%20streaming%20platform%20style&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '日韩热剧连播不间断',
    description: '最新韩剧、日剧同步更新，高甜恋爱、悬疑推理、职场励志，满足你的追剧需求。',
    tag: '剧集连播',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20aesthetic%20visual%20with%20warm%20romantic%20amber%20tones%2C%20soft%20cinematic%20lighting%2C%20elegant%20dark%20background%2C%20emotional%20storytelling%20atmosphere%2C%20premium%20streaming%20style&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '国产高分剧集精选',
    description: '精选近年来口碑爆棚的国产剧集，古装、都市、悬疑题材全覆盖，豆瓣高分认证。',
    tag: '口碑佳作',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20cinematic%20visual%20with%20rich%20crimson%20and%20gold%20accents%2C%20elegant%20composition%20on%20dark%20backdrop%2C%20traditional%20aesthetic%20meets%20modern%20streaming%2C%20premium%20quality&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '午夜剧场·精选内容',
    description: '深夜专属精选内容，汇聚蜜桃视频、91视频等平台热门资源，私密观影体验。',
    tag: '午夜精选',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20night%20cinema%20atmosphere%20with%20deep%20burgundy%20and%20warm%20amber%20lighting%2C%20intimate%20dark%20composition%2C%20velvety%20shadows%2C%20sophisticated%20adult%20entertainment%20aesthetic&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '热门动漫追番指南',
    description: '最新番剧一集不落，经典番剧随时重温，热血、治愈、异世界题材应有尽有。',
    tag: '动漫专区',
    image: 'https://readdy.ai/api/search-image?query=Anime%20visual%20aesthetic%20with%20vibrant%20warm%20orange%20and%20red%20energy%20streaks%2C%20dynamic%20composition%20on%20dark%20background%2C%20modern%20animation%20style%2C%20action%20atmosphere%2C%20premium%20streaming&width=800&height=450&seq=carousel-05&orientation=landscape',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '【4K修复】经典港片高清重制合集',
    desc: '张国荣、周星驰等经典作品4K修复版上线，重温港片黄金时代',
    views: '128.6万',
    duration: '合集',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20nostalgic%20visual%20with%20warm%20golden%20lighting%2C%20film%20poster%20aesthetic%2C%20vintage%20atmosphere%20with%20modern%20restoration%20feel%2C%20dark%20elegant%20background&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '2026年最新院线大片抢先看',
    desc: '暑期档热门影片第一时间上线，高清画质流畅不缓冲，多线路保障',
    views: '96.3万',
    duration: '连载',
    image: 'https://readdy.ai/api/search-image?query=Modern%20cinema%20blockbuster%20visual%20with%20dramatic%20red%20and%20amber%20lighting%2C%20action%20movie%20atmosphere%2C%20dynamic%20dark%20composition%2C%20premium%20theater%20experience&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '热播韩剧TOP10一次看完',
    desc: '从《黑暗荣耀》到最新热剧，韩剧迷不可错过的必看清单',
    views: '85.7万',
    duration: '合集',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20collection%20visual%20with%20warm%20romantic%20amber%20tones%2C%20emotional%20cinematic%20lighting%2C%20sophisticated%20dark%20composition%2C%20premium%20streaming%20platform%20aesthetic&width=800&height=450&seq=media-03&orientation=landscape',
  },
];

export const cardItems = [
  {
    id: 1,
    title: '《暗夜追踪》2026最新动作大片',
    desc: '顶级制作团队倾力打造，动作场面燃爆全场，高清画质沉浸体验',
    tag: '动作大片',
    image: 'https://readdy.ai/api/search-image?query=Intense%20action%20thriller%20movie%20visual%20with%20dramatic%20red%20lighting%2C%20dark%20urban%20atmosphere%2C%20suspenseful%20cinematic%20composition%2C%20professional%20film%20poster%20style%2C%20warm%20accents&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《恋爱公式》高甜浪漫喜剧',
    desc: '当红小生花旦主演，轻松甜蜜笑料不断，这个夏天最治愈的爱情故事',
    tag: '浪漫喜剧',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20film%20visual%20with%20soft%20warm%20golden%20lighting%2C%20intimate%20atmosphere%2C%20elegant%20dark%20composition%2C%20sweet%20cinematic%20aesthetic%2C%20premium%20quality&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '《古墓秘境》探险悬疑巨制',
    desc: '神秘古墓、惊险探秘，视觉效果震撼，国产探险题材新标杆',
    tag: '悬疑探险',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20adventure%20film%20visual%20with%20warm%20torch%20lighting%2C%20ancient%20tomb%20atmosphere%2C%20dramatic%20dark%20composition%2C%20cinematic%20exploration%20aesthetic&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '《都市夜话》深夜情感剧场',
    desc: '真实故事改编，探讨都市男女情感话题，蜜桃视频热门推荐',
    tag: '情感剧场',
    image: 'https://readdy.ai/api/search-image?query=Intimate%20night%20drama%20visual%20with%20warm%20burgundy%20and%20amber%20tones%2C%20urban%20night%20atmosphere%2C%20emotional%20cinematic%20composition%2C%20sophisticated%20dark%20background&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '《星际征途》科幻史诗系列',
    desc: '媲美好莱坞的视觉特效，宏大的宇宙世界观，科幻迷年度必看',
    tag: '科幻巨制',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20film%20visual%20with%20warm%20orange%20nebula%20lighting%2C%20space%20atmosphere%2C%20dramatic%20dark%20cosmic%20composition%2C%20premium%20cinematic%20quality&width=600&height=400&seq=card-05&orientation=landscape',
  },
  {
    id: 6,
    title: '《笑林外传》爆笑喜剧合集',
    desc: '经典喜剧片段精选，搞笑名场面一次看够，解压放松最佳选择',
    tag: '爆笑喜剧',
    image: 'https://readdy.ai/api/search-image?query=Comedy%20film%20visual%20with%20bright%20warm%20lighting%2C%20fun%20playful%20atmosphere%2C%20colorful%20accents%20on%20dark%20background%2C%20entertaining%20cinematic%20composition&width=600&height=400&seq=card-06&orientation=landscape',
  },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '暗夜追踪', type: '电影', hot: '🔥 98.6', change: 'up' },
  { id: 2, rank: 2, title: '恋爱公式', type: '电影', hot: '🔥 95.2', change: 'up' },
  { id: 3, rank: 3, title: '都市夜话 · 第三季', type: '剧集', hot: '🔥 92.8', change: 'same' },
  { id: 4, rank: 4, title: '古墓秘境', type: '电影', hot: '🔥 89.4', change: 'up' },
  { id: 5, rank: 5, title: '蜜桃精选合集', type: '合集', hot: '🔥 87.1', change: 'down' },
  { id: 6, rank: 6, title: '星际征途', type: '电影', hot: '🔥 84.5', change: 'up' },
  { id: 7, rank: 7, title: '91独家推荐', type: '专题', hot: '🔥 81.3', change: 'new' },
];

export const appInfo = {
  title: '苹果视频APP',
  description: '下载苹果视频APP，畅享更流畅的观影体验。支持离线缓存、画质切换、倍速播放，随时随地想看就看。汇聚香蕉视频、红桃视频、91视频、蜜桃视频等全网热门资源。',
  features: ['离线缓存', '高清画质', '倍速播放', '免广告'],
  image: 'https://readdy.ai/api/search-image?query=Mobile%20streaming%20app%20interface%20mockup%20on%20dark%20theme%2C%20cinematic%20red%20and%20amber%20accent%20colors%2C%20modern%20video%20platform%20design%2C%20elegant%20smartphone%20display%2C%20premium%20entertainment%20app%20aesthetic&width=400&height=800&seq=app-01&orientation=portrait',
};

export const aboutInfo = {
  title: '关于苹果视频',
  paragraphs: [
    '苹果视频是一个专注于免费高清影视资源聚合的在线平台，致力于为广大用户提供流畅、便捷的观影体验。我们汇聚了香蕉视频、红桃视频、91视频、蜜桃视频等多个热门平台的优质资源，覆盖电影、电视剧、动漫、综艺等全品类内容。',
    '自上线以来，苹果视频始终坚持"免费、高清、流畅"的核心理念，通过多线路智能调度技术，确保用户在任何网络环境下都能享受不缓冲的观影体验。我们的内容团队每日更新，第一时间同步最新热播资源。',
    '无论您喜欢动作大片、浪漫喜剧、悬疑推理还是动漫番剧，苹果视频都能满足您的需求。全平台适配让您可以在PC、手机、平板上无缝切换观影。',
  ],
};

export const indexItems = [
  {
    id: 1,
    title: '电影大全',
    desc: '动作、喜剧、科幻、悬疑全类型覆盖',
    count: '5.2万+',
    icon: 'ri-film-line',
  },
  {
    id: 2,
    title: '电视剧集',
    desc: '国产剧、韩剧、日剧、美剧一网打尽',
    count: '3.8万+',
    icon: 'ri-tv-line',
  },
  {
    id: 3,
    title: '动漫番剧',
    desc: '热血、治愈、异世界，追番不停歇',
    count: '2.1万+',
    icon: 'ri-rocket-line',
  },
  {
    id: 4,
    title: '综艺娱乐',
    desc: '热门综艺、搞笑合集、真人秀精选',
    count: '1.5万+',
    icon: 'ri-emotion-laugh-line',
  },
  {
    id: 5,
    title: '午夜剧场',
    desc: '深夜专属精选内容，私密观影体验',
    count: '8.6k+',
    icon: 'ri-moon-line',
  },
  {
    id: 6,
    title: '纪录片',
    desc: '自然、历史、科技，开拓你的视野',
    count: '6.2k+',
    icon: 'ri-earth-line',
  },
  {
    id: 7,
    title: '高清专区',
    desc: '1080P/4K高清资源，视觉盛宴',
    count: '1.2万+',
    icon: 'ri-4k-line',
  },
  {
    id: 8,
    title: '热门合集',
    desc: '经典系列、导演作品集、主题精选',
    count: '9.3k+',
    icon: 'ri-stack-line',
  },
];

export const contactInfo = {
  title: '联系我们',
  description: '如果您在使用过程中遇到任何问题，或有内容合作、资源投稿等需求，欢迎通过以下方式与我们取得联系。我们重视每一条反馈，通常在工作日24小时内给予回复。',
  email: 'feedback@pingguovideo.com',
  qq: '1234567890',
  wechat: 'pingguovideo',
};

export const featureItems = [
  {
    id: 1,
    title: '免费高清',
    desc: '所有资源免费观看，支持1080P/4K高清画质，无需付费即可享受影院级观影体验',
    icon: 'ri-vip-crown-line',
  },
  {
    id: 2,
    title: '流畅不缓冲',
    desc: '多线路智能调度，自动选择最优播放源，确保在任何网络环境下都能流畅播放不卡顿',
    icon: 'ri-speed-up-line',
  },
  {
    id: 3,
    title: '全平台覆盖',
    desc: 'PC、手机、平板无缝切换，网页版即开即看，APP端支持离线缓存随时随地观影',
    icon: 'ri-device-line',
  },
];

export const updateItems = [
  {
    id: 1,
    date: '2026-07-30',
    title: '新增4K高清专区上线',
    desc: '首批500+部经典影片完成4K修复，画质全面提升，带来全新视觉体验。',
  },
  {
    id: 2,
    date: '2026-07-28',
    title: '播放器全面升级至v3.0',
    desc: '新增智能线路切换、记忆播放进度、画中画模式等多项实用功能。',
  },
  {
    id: 3,
    date: '2026-07-25',
    title: '香蕉视频热门资源同步',
    desc: '完成与香蕉视频最新热门内容的同步更新，新增200+部精选影片。',
  },
  {
    id: 4,
    date: '2026-07-22',
    title: '红桃视频专区正式上线',
    desc: '全新红桃视频专区独立呈现，分类更清晰，浏览更便捷，每日更新。',
  },
  {
    id: 5,
    date: '2026-07-18',
    title: '移动端APP v2.5版本发布',
    desc: '优化离线缓存速度，新增倍速播放功能，修复已知问题，体验更流畅。',
  },
  {
    id: 6,
    date: '2026-07-15',
    title: '蜜桃视频资源库扩容',
    desc: '蜜桃视频专区新增1000+部高清资源，涵盖多个热门分类。',
  },
  {
    id: 7,
    date: '2026-07-10',
    title: '91视频频道全新改版',
    desc: '91视频频道页面全新设计，推荐算法升级，发现更多你喜欢的精彩内容。',
  },
];

export const commentItems = [
  {
    id: 1,
    name: '影视发烧友',
    text: '用了苹果视频半年多了，资源更新真的快！新片基本上第一时间就能看到，而且画质清晰、播放流畅，已经推荐给身边所有朋友了。',
    date: '2026-07-29',
    rating: 5,
  },
  {
    id: 2,
    name: '追剧小达人',
    text: '之前用其他平台总是卡顿，换到苹果视频后体验完全不一样了。多线路切换功能太实用了，看韩剧再也不用担心缓冲问题，强烈推荐！',
    date: '2026-07-28',
    rating: 5,
  },
  {
    id: 3,
    name: '深夜观影者',
    text: '午夜剧场内容很丰富，蜜桃视频和91视频的资源都能在这里找到，而且分类清晰、更新及时，私密观影体验很棒。',
    date: '2026-07-27',
    rating: 4,
  },
  {
    id: 4,
    name: '动漫迷阿杰',
    text: '作为一个重度动漫爱好者，苹果视频的番剧库真的让我惊喜。新番同步快、老番也能找到，画质选择多，是目前用过最好的免费观影平台。',
    date: '2026-07-26',
    rating: 5,
  },
];